// Point d'entrée principal pour toutes les configurations
import { audiConfig } from './brands/audi.js';
import { cupraConfig } from './brands/cupra.js';
import { seatConfig } from './brands/seat.js';
import { skodaConfig } from './brands/skoda.js';
import { vwConfig } from './brands/vw.js';
import { vwuConfig } from './brands/vwu.js';
import {
  CALENDAR_CONFIG,
  FORM_FIELDS,
  FORMATS,
  ICONS,
  ORIGIN_MAPPING,
  URL_PARAMS,
} from './shared/constants.js';
import { DEFAULT_BRAND, DEFAULT_CONFIG } from './shared/defaults.js';

// Configuration complète par marque (fusion des configs spécifiques + partagées)
export const BRAND_CONFIGS = {
  audi: {
    ...DEFAULT_CONFIG,
    ...audiConfig,
    // Fusion des constantes partagées
    calendar: CALENDAR_CONFIG,
    formats: FORMATS,
    icons: ICONS,
    urlParams: URL_PARAMS,
    formFields: FORM_FIELDS,
    originMapping: ORIGIN_MAPPING,
  },
  skoda: {
    ...DEFAULT_CONFIG,
    ...skodaConfig,
    // Fusion des constantes partagées
    calendar: CALENDAR_CONFIG,
    formats: FORMATS,
    icons: ICONS,
    urlParams: URL_PARAMS,
    formFields: FORM_FIELDS,
    originMapping: ORIGIN_MAPPING,
  },
  cupra: {
    ...DEFAULT_CONFIG,
    ...cupraConfig,
    // Fusion des constantes partagées
    calendar: CALENDAR_CONFIG,
    formats: FORMATS,
    icons: ICONS,
    urlParams: URL_PARAMS,
    formFields: FORM_FIELDS,
    originMapping: ORIGIN_MAPPING,
  },
  seat: {
    ...DEFAULT_CONFIG,
    ...seatConfig,
    // Fusion des constantes partagées
    calendar: CALENDAR_CONFIG,
    formats: FORMATS,
    icons: ICONS,
    urlParams: URL_PARAMS,
    formFields: FORM_FIELDS,
    originMapping: ORIGIN_MAPPING,
  },
  vw: {
    ...DEFAULT_CONFIG,
    ...vwConfig,
    // Fusion des constantes partagées
    calendar: CALENDAR_CONFIG,
    formats: FORMATS,
    icons: ICONS,
    urlParams: URL_PARAMS,
    formFields: FORM_FIELDS,
    originMapping: ORIGIN_MAPPING,
  },
  vwu: {
    ...DEFAULT_CONFIG,
    ...vwuConfig,
    // Fusion des constantes partagées
    calendar: CALENDAR_CONFIG,
    formats: FORMATS,
    icons: ICONS,
    urlParams: URL_PARAMS,
    formFields: FORM_FIELDS,
    originMapping: ORIGIN_MAPPING,
  },
};

export { DEFAULT_BRAND, DEFAULT_CONFIG } from './shared/defaults.js';
export {
  CALENDAR_CONFIG,
  FORM_FIELDS,
  FORMATS,
  ICONS,
  ORIGIN_MAPPING,
  URL_PARAMS,
} from './shared/constants.js';

// Fonction utilitaire pour obtenir une configuration de marque
export const getBrandConfig = (brandName) => {
  return BRAND_CONFIGS[brandName] || BRAND_CONFIGS[DEFAULT_BRAND];
};

// Fonction utilitaire pour lister toutes les marques disponibles
export const getAvailableBrands = () => {
  return Object.keys(BRAND_CONFIGS);
};
